export default class BookmarkCounter {
  constructor ($el) {
    this.render = this.render.bind(this)
    this.onBookmarkRemoved = this.onBookmarkRemoved.bind(this)
    this.onBookmarkAdded = this.onBookmarkAdded.bind(this)
    this.$el = $el
    this.jobs = new Set()
    this.addEventListeners()
    this.render()
  }

  addEventListeners () {
    EventBus.on('bookmarks:added', this.onBookmarkAdded)
    EventBus.on('bookmarks:removed', this.onBookmarkRemoved)
  };

  removeEventListeners () {
    EventBus.off('bookmarks:added', this.onBookmarkAdded)
    EventBus.off('bookmarks:removed', this.onBookmarkRemoved)
  };

  onBookmarkAdded (e, { jobId }) {
    if (!jobId) { return }

    this.jobs.add(jobId)
    this.render()
  };

  onBookmarkRemoved (e, { jobId }) {
    if (!jobId) { return }

    this.jobs.delete(jobId)

    if (this.jobs.size === 0) { EventBus.trigger('bookmarks:empty') }

    return this.render()
  };

  render () {
    this.$el.find('.js-count').html(this.jobs.size)
  };
}
